/* ============================================================
   Guida ai nodi — TieTiè Sartoriale
   Player passo-passo + griglia filtrabile + filo d'oro
   ============================================================ */
(function () {
  'use strict';

  /* ---------- Sagome dei nodi finiti (hero + card) ---------- */
  var BLADES = {
    wide: 'M84 80 C74 108 66 142 68 162 L100 248 L132 162 C134 142 126 108 116 80 Z',
    slim: 'M88 80 C82 110 76 142 78 162 L100 246 L122 162 C124 142 118 110 112 80 Z',
    asym: 'M88 80 C82 110 78 140 80 160 L104 246 L124 158 C124 140 118 108 112 80 Z'
  };
  var SVGNS = 'http://www.w3.org/2000/svg';

  function buildThread(svg, knotPaths, bladeKey) {
    svg.innerHTML = '';
    knotPaths.concat([BLADES[bladeKey] || BLADES.slim]).forEach(function (d, i) {
      var p = document.createElementNS(SVGNS, 'path');
      p.setAttribute('d', d);
      p.setAttribute('pathLength', '1');
      p.style.setProperty('--i', i);
      svg.appendChild(p);
    });
  }
  function playThread(svg) {
    svg.classList.remove('play');
    void svg.getBoundingClientRect();
    svg.classList.add('play');
  }

  /* ---------- Scene passo-passo (diagrammi del gesto) ---------- */
  var P = {
    collar:  '<rect class="collar" x="76" y="10" width="88" height="15" rx="7.5"/>',
    loop:    '<ellipse class="loop" cx="120" cy="36" rx="38" ry="11"/>',
    thin:    '<path class="thin" d="M110 46 L107 116 L119 116 L121 46 Z"/>',
    start:   '<path class="wide" d="M130 46 L128 146 L136 156 L144 146 L142 46 Z"/>',
    crossLeft: '<path class="wide{U}" d="M132 56 L56 84 L61 101 L136 71 Z"/>',
    behindRight: '<path class="wide under" d="M134 58 C152 68 160 92 154 116 L145 118 C149 94 144 78 128 68 Z"/>',
    upLoop:  '<path class="wide" d="M116 46 L114 8 L128 8 L130 46 Z"/>',
    downLoop:'<path class="wide" d="M114 44 L113 94 L125 94 L128 44 Z"/>',
    frontRight: '<path class="wide" d="M110 64 L188 86 L183 103 L104 78 Z"/>',
    throughCappio: '<path class="wide" d="M192 56 L98 67 L100 81 L190 72 Z"/>',
    cappio:  '<rect class="cappio" x="90" y="64" width="58" height="14" rx="7"/>',
    knot:    '<path class="knot" d="M94 34 L146 34 L120 64 Z"/>',
    bladeFinal: '<path class="wide" d="M106 64 L104 146 L120 158 L136 146 L134 64 Z"/>',
    lblLarga: '<text class="lbl" x="150" y="152">larga</text>',
    lblStretta: '<text class="lbl" x="64" y="126">stretta</text>'
  };
  var ARROWS = {
    cross:   'M192 50 C156 38 104 44 68 72',
    behind:  'M64 68 C56 30 184 30 180 86',
    front:   'M58 72 C104 52 158 58 196 82',
    up:      'M124 100 L124 16',
    down:    'M124 12 L124 88',
    through: 'M198 62 L112 70',
    tighten: 'M120 118 L120 78',
    turn:    'M150 128 A28 28 0 1 1 122 100'
  };
  var MARKER = '<defs><marker id="gn-ah" viewBox="0 0 10 10" refX="8" refY="5" markerWidth="6.5" markerHeight="6.5" orient="auto-start-reverse"><path d="M0 0 L10 5 L0 10 z" fill="#e4cf9f"/></marker></defs>';

  var SCENES = {
    start:      { parts: ['collar', 'loop', 'thin', 'start', 'lblLarga', 'lblStretta'] },
    crossOver:  { parts: ['collar', 'loop', 'thin', 'crossLeft'], arrow: 'cross' },
    crossUnder: { parts: ['collar', 'loop', 'crossLeftUnder', 'thin'], arrow: 'cross' },
    behind:     { parts: ['collar', 'loop', 'thin', 'behindRight'], arrow: 'behind' },
    front:      { parts: ['collar', 'loop', 'thin', 'frontRight'], arrow: 'front' },
    up:         { parts: ['collar', 'loop', 'thin', 'upLoop'], arrow: 'up' },
    down:       { parts: ['collar', 'loop', 'thin', 'downLoop'], arrow: 'down' },
    through:    { parts: ['collar', 'loop', 'thin', 'cappio', 'throughCappio'], arrow: 'through' },
    tighten:    { parts: ['collar', 'loop', 'knot', 'bladeFinal'], arrow: 'tighten' },
    turn:       { parts: ['collar', 'loop', 'thin', 'start'], arrow: 'turn' }
  };
  function sceneMarkup(move) {
    var s = SCENES[move] || SCENES.start;
    var html = MARKER + '<g class="anim">';
    s.parts.forEach(function (k) {
      if (k === 'crossLeftUnder') html += P.crossLeft.replace('{U}', ' under');
      else html += (P[k] || '').replace('{U}', '');
    });
    if (s.arrow) html += '<path class="move-arrow" d="' + ARROWS[s.arrow] + '" marker-end="url(#gn-ah)"/>';
    return html + '</g>';
  }

  /* ---------- I 10 nodi ---------- */
  var KNOTS = [
    {
      id: 'quattro-mani', name: 'Quattro Mani', aka: 'Four-in-Hand', level: 1, time: '30 sec',
      collar: 'Button-down, italiano', occ: 'Ogni giorno', tags: [],
      story: 'Il nodo dei gentiluomini di tutti i giorni: snello, leggermente asimmetrico, mai rigido. È il primo che si impara e quello che si porta per tutta la vita.',
      tip: 'Non stringerlo troppo: la sua eleganza è nella leggerezza. Crea sempre la fossetta sotto il nodo con un dito.',
      knot: ['M85 32 L115 32 L110 82 L90 80 Z', 'M100 34 L100 78'], blade: 'asym',
      steps: [
        ['start', 'Cravatta al collo, cucitura dietro: pala larga a destra, nettamente più lunga della stretta.'],
        ['crossOver', 'Porta la pala larga sopra la stretta, all’altezza del diaframma.'],
        ['behind', 'Passala dietro e riportala sul lato destro.'],
        ['front', 'Ripassa davanti formando il cappio.'],
        ['up', 'Sali dietro il girocollo, dal basso verso l’alto.'],
        ['through', 'Scendi attraverso il cappio che hai formato.'],
        ['tighten', 'Stringi facendo scivolare il nodo al colletto, creando la fossetta.']
      ]
    },
    {
      id: 'orientale', name: 'Orientale', aka: 'Simple Knot', level: 1, time: '20 sec',
      collar: 'Colletti stretti', occ: 'Casual', tags: [],
      story: 'Il più semplice che esista: piccolo, compatto, discreto. Perfetto per le cravatte in lino e per i colletti stretti dell’estate.',
      tip: 'Con la seta pesante risulta troppo piccolo: riservalo ai tessuti leggeri e alle giornate informali.',
      knot: ['M88 34 L112 34 L107 72 L93 72 Z'], blade: 'slim',
      steps: [
        ['start', 'Cravatta al collo: questa volta la pala larga lavora partendo da sotto.'],
        ['crossUnder', 'Incrocia la pala larga sotto quella stretta.'],
        ['front', 'Riporta la pala larga davanti, sopra la stretta.'],
        ['up', 'Sali dietro il girocollo.'],
        ['through', 'Scendi nel cappio e stringi con delicatezza.']
      ]
    },
    {
      id: 'pratt', name: 'Pratt', aka: 'Shelby Knot', level: 1, time: '40 sec',
      collar: 'Italiano, semi-francese', occ: 'Ufficio', tags: [],
      story: 'Pulito, simmetrico, di media grandezza: il nodo di chi vuole ordine senza formalità eccessiva. Jerry Pratt lo usò per trent’anni prima di rivelarlo al mondo.',
      tip: 'Si parte con la cravatta al rovescio, cucitura verso l’esterno: ricordalo o il nodo verrà storto.',
      knot: ['M84 32 L116 32 L109 80 L91 80 Z', 'M100 34 L100 78'], blade: 'slim',
      steps: [
        ['turn', 'Inizia con la cravatta al rovescio, cucitura verso l’esterno, pala larga sotto la stretta.'],
        ['up', 'Sali attraverso il girocollo e scendi dall’altro lato.'],
        ['front', 'Porta la pala davanti, da un lato all’altro.'],
        ['up', 'Risali dietro il girocollo.'],
        ['through', 'Scendi nel cappio frontale.'],
        ['tighten', 'Centra e stringi: simmetria perfetta.']
      ]
    },
    {
      id: 'kelvin', name: 'Kelvin', aka: '—', level: 2, time: '45 sec',
      collar: 'Italiano', occ: 'Ufficio', tags: [],
      story: 'Il fratello composto del Quattro Mani: un giro in più davanti e l’asimmetria diventa carattere. Prende il nome da Lord Kelvin, che studiava i nodi come strutture.',
      tip: 'Il secondo passaggio davanti deve essere morbido: se stringi subito, il nodo perde volume.',
      knot: ['M83 32 L117 32 L100 82 Z', 'M86 42 L114 42'], blade: 'slim',
      steps: [
        ['start', 'Cravatta al rovescio, cucitura fuori: pala larga sotto, più lunga.'],
        ['front', 'Passa la pala larga davanti una prima volta.'],
        ['front', 'Ripassa davanti una seconda volta: ecco la fascia doppia.'],
        ['up', 'Sali dietro il girocollo.'],
        ['through', 'Scendi dentro la fascia.'],
        ['tighten', 'Regola i due giri e stringi.']
      ]
    },
    {
      id: 'mezzo-windsor', name: 'Mezzo Windsor', aka: 'Half Windsor', level: 2, time: '1 min',
      collar: 'Semi-francese', occ: 'Ufficio, sera', tags: ['cerimonia'],
      story: 'Il compromesso perfetto: triangolare e simmetrico come il Windsor, ma senza la sua imponenza. Il nodo più versatile dell’armadio.',
      tip: 'Con la pala da 7,5 cm delle TieTiè viene proporzionato: non tirare troppo la prima fascia o risulterà piccolo.',
      knot: ['M85 32 L115 32 L100 80 Z', 'M93 32 L98 80'], blade: 'slim',
      steps: [
        ['start', 'Pala larga a destra, più lunga di un palmo.'],
        ['crossOver', 'Porta la pala larga sopra la stretta.'],
        ['up', 'Sali attraverso il girocollo e scendi sul lato.'],
        ['front', 'Attraversa il davanti formando la fascia.'],
        ['up', 'Risali dietro il girocollo.'],
        ['through', 'Scendi dentro la fascia.'],
        ['tighten', 'Centra il triangolo e stringi verso l’alto.']
      ]
    },
    {
      id: 'windsor', name: 'Windsor', aka: 'Full Windsor', level: 2, time: '1 min e mezzo',
      collar: 'Francese, cutaway', occ: 'Cerimonia, affari', tags: ['cerimonia'],
      story: 'Il nodo delle grandi occasioni: triangolo ampio, simmetrico, autorevole. Reso celebre dal Duca di Windsor, chiede colletti larghi e seta di qualità.',
      tip: 'È un nodo che ‘mangia’ molta seta: parti con la pala stretta molto corta o le proporzioni non torneranno.',
      knot: ['M80 30 L120 30 L100 84 Z', 'M88 30 L97 84', 'M112 30 L103 84'], blade: 'wide',
      steps: [
        ['start', 'Pala larga a destra, molto lunga: il Windsor consuma molta seta.'],
        ['crossOver', 'Porta la pala larga sopra la stretta.'],
        ['up', 'Sali nel girocollo e scendi a sinistra.'],
        ['behind', 'Passa dietro verso destra.'],
        ['up', 'Risali nel girocollo e scendi sul davanti.'],
        ['front', 'Attraversa il davanti formando la fascia larga.'],
        ['through', 'Sali dietro e scendi dentro la fascia.'],
        ['tighten', 'Allinea il triangolo, stringi e crea la fossetta.']
      ]
    },
    {
      id: 'grantchester', name: 'Grantchester', aka: '—', level: 2, time: '1 min',
      collar: 'Semi-francese', occ: 'Sera, eventi', tags: ['cerimonia'],
      story: 'Il Quattro Mani degli uomini alti: giri extra che lo rendono pieno e scenografico senza la rigidità del Windsor.',
      tip: 'Ogni giro in più consuma seta: misura la pala stretta sul secondo bottone della camicia prima di iniziare.',
      knot: ['M82 30 L118 30 C119 54 115 70 110 82 L90 82 C85 70 81 54 82 30 Z', 'M100 32 L100 80'], blade: 'wide',
      steps: [
        ['start', 'Pala larga a destra, extra lunga: servono giri in più.'],
        ['crossOver', 'Incrocia la pala larga sopra la stretta.'],
        ['front', 'Gira davanti una volta.'],
        ['front', 'Gira davanti una seconda volta, morbido.'],
        ['up', 'Sali dietro il girocollo.'],
        ['through', 'Scendi dentro la fascia doppia.'],
        ['tighten', 'Distribuisci i giri e stringi.']
      ]
    },
    {
      id: 'onassis', name: 'Onassis', aka: '—', level: 1, time: '30 sec',
      collar: 'Italiano, button-down', occ: 'Casual chic', tags: [],
      story: 'Il vezzo di Aristotele Onassis: un nodo semplice coperto da una fascia piatta di seta. Il risultato è rilassato ma immediatamente riconoscibile.',
      tip: 'Funziona solo con seta morbida e pala larga: con tessuti rigidi la fascia si impenna.',
      knot: ['M84 32 L116 32 L110 78 L90 78 Z', 'M82 44 L118 44 L118 68 L82 68 Z'], blade: 'slim',
      steps: [
        ['start', 'Cravatta al collo: annoda prima un Quattro Mani, lasciandolo morbido.'],
        ['front', 'Riporta la pala larga davanti, coprendo il nodo come una fascia.'],
        ['behind', 'Passa la fascia dietro il nodo e fissala dietro il girocollo.'],
        ['tighten', 'Appiattisci la fascia con le dita: deve restare morbida, non tesa.']
      ]
    },
    {
      id: 'trinity', name: 'Trinity', aka: '—', level: 3, time: '2–3 min',
      collar: 'Semi-francese', occ: 'Sera, eventi', tags: ['cerimonia'],
      story: 'Tre pieghe che si rincorrono in una girandola a tre punte: un nodo-scultura per chi ha già sicurezza e vuole farsi notare.',
      tip: 'Si annoda con la pala stretta: la larga resta ferma. Controlla ogni piega prima di passare alla successiva.',
      knot: ['M84 32 L116 32 L100 84 Z', 'M100 84 L100 52', 'M100 84 L87 38', 'M100 84 L113 38'], blade: 'slim',
      steps: [
        ['start', 'Si lavora con la pala stretta: la larga resta ferma al centro.'],
        ['crossOver', 'Porta la stretta sopra la larga.'],
        ['up', 'Sali nel girocollo e scendi sul lato: prima piega.'],
        ['front', 'Attraversa il davanti: seconda piega.'],
        ['up', 'Risali e scendi formando la terza piega.'],
        ['front', 'Gira davanti completando la girandola.'],
        ['through', 'Passa la pala attraverso le pieghe.'],
        ['tighten', 'Equilibra le tre punte una a una.']
      ]
    },
    {
      id: 'eldredge', name: 'Eldredge', aka: '—', level: 3, time: '3–4 min',
      collar: 'Semi-francese', occ: 'Gran sera', tags: ['cerimonia'],
      story: 'Il nodo da collezione: una treccia di seta intrecciata che sembra impossibile. Jeffrey Eldredge lo inventò nel 2007, stanco dei soliti nodi.',
      tip: 'Usa seta leggera e non stringere mai le pieghe: la treccia deve restare piena. Controlla lo specchio a ogni passaggio.',
      knot: ['M84 30 L116 30 L110 84 L90 84 Z', 'M88 36 L100 45 L112 36', 'M90 48 L100 57 L110 48', 'M92 60 L100 69 L108 60', 'M94 71 L100 79 L106 71'], blade: 'slim',
      steps: [
        ['start', 'Si annoda con la pala stretta; la larga non si muove.'],
        ['crossOver', 'Porta la stretta sopra la larga.'],
        ['up', 'Sali nel girocollo e scendi a sinistra.'],
        ['front', 'Attraversa davanti e ferma la prima piega.'],
        ['behind', 'Passa dietro: seconda fascia della treccia.'],
        ['front', 'Intreccia davanti alternando sopra e sotto.'],
        ['up', 'Risali e completa la spiga.'],
        ['through', 'Infila la pala nell’ultima piega.'],
        ['tighten', 'Apri la treccia con le dita e fissa il nodo.']
      ]
    }
  ];

  var LVL = { 1: 'Facile', 2: 'Medio', 3: 'Difficile' };
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.addEventListener('DOMContentLoaded', function () {
    var root = document.getElementById('guida-nodi');
    if (!root) return;

    /* ---------- Player ---------- */
    var sceneSvg = document.getElementById('gnScene');
    var capN = document.getElementById('gnCapN');
    var capText = document.getElementById('gnCapText');
    var dotsWrap = document.getElementById('gnDots');
    var stepsWrap = document.getElementById('gnSteps');
    var ppBtn = document.getElementById('gnPP');
    var sceneWrap = document.getElementById('gnSceneWrap');

    var curSteps = [], stepIdx = 0, playing = !reduced, timer = null;

    function goStep(i) {
      stepIdx = (i + curSteps.length) % curSteps.length;
      sceneSvg.innerHTML = sceneMarkup(curSteps[stepIdx][0]);
      capN.innerHTML = (stepIdx + 1) + '<span> / ' + curSteps.length + '</span>';
      capText.textContent = curSteps[stepIdx][1];
      Array.prototype.forEach.call(dotsWrap.children, function (d, j) {
        d.classList.toggle('on', j === stepIdx);
        d.classList.toggle('done', j < stepIdx);
      });
      Array.prototype.forEach.call(stepsWrap.children, function (r, j) {
        r.classList.toggle('on', j === stepIdx);
      });
    }
    function startAuto() {
      stopAuto();
      if (playing) timer = setInterval(function () {
        if (!document.hidden) goStep(stepIdx + 1);
      }, 3000);
    }
    function stopAuto() { if (timer) { clearInterval(timer); timer = null; } }

    document.getElementById('gnPrev').addEventListener('click', function () { goStep(stepIdx - 1); startAuto(); });
    document.getElementById('gnNext').addEventListener('click', function () { goStep(stepIdx + 1); startAuto(); });
    ppBtn.addEventListener('click', function () {
      playing = !playing;
      ppBtn.textContent = playing ? '❚❚' : '▶';
      ppBtn.setAttribute('aria-label', playing ? 'Metti in pausa' : 'Riproduci');
      if (playing) startAuto(); else stopAuto();
    });
    sceneWrap.addEventListener('mouseenter', stopAuto);
    sceneWrap.addEventListener('mouseleave', startAuto);

    /* ---------- Griglia ---------- */
    var grid = document.getElementById('gnGrid');
    KNOTS.forEach(function (k, idx) {
      var card = document.createElement('article');
      card.className = 'gn-card gn-rev';
      card.style.setProperty('--d', (idx % 5 * 0.06) + 's');
      card.dataset.id = k.id;
      card.dataset.level = k.level;
      card.dataset.cer = k.tags.indexOf('cerimonia') > -1 ? '1' : '0';
      card.setAttribute('role', 'button');
      card.setAttribute('tabindex', '0');
      card.setAttribute('aria-label', 'Vedi il nodo ' + k.name);
      card.innerHTML =
        '<svg class="gn-thread" viewBox="0 0 200 268" aria-hidden="true"></svg>' +
        '<h3>' + k.name + '</h3>' +
        '<p class="gn-aka">' + k.aka + '</p>' +
        '<div class="gn-dots">' + [1, 2, 3].map(function (i) { return '<i class="' + (i <= k.level ? 'f' : '') + '"></i>'; }).join('') + '</div>' +
        '<p class="gn-occ">' + k.occ + '</p>';
      grid.appendChild(card);
      buildThread(card.querySelector('svg'), k.knot, k.blade);
      var open = function () { selectKnot(k.id, true); };
      card.addEventListener('click', open);
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); }
      });
    });

    document.getElementById('gnChips').addEventListener('click', function (e) {
      var b = e.target.closest('.gn-chip');
      if (!b) return;
      document.querySelectorAll('.gn-chip').forEach(function (c) { c.classList.remove('on'); });
      b.classList.add('on');
      var f = b.dataset.f;
      document.querySelectorAll('.gn-card').forEach(function (c) {
        var show = f === 'all' || c.dataset.level === f || (f === 'cerimonia' && c.dataset.cer === '1');
        c.classList.toggle('is-hidden', !show);
      });
    });

    /* ---------- Selezione nodo ---------- */
    function selectKnot(id, scroll) {
      var k = KNOTS.find(function (x) { return x.id === id; }) || KNOTS[0];
      document.querySelectorAll('.gn-card').forEach(function (c) { c.classList.toggle('on', c.dataset.id === k.id); });
      document.getElementById('gnName').textContent = k.name;
      document.getElementById('gnAka').textContent = k.aka + ' · ' + LVL[k.level];
      document.getElementById('gnStory').textContent = k.story;
      document.getElementById('gnLevel').innerHTML = [1, 2, 3].map(function (i) { return '<i class="' + (i <= k.level ? 'f' : '') + '"></i>'; }).join('');
      document.getElementById('gnTime').textContent = k.time;
      document.getElementById('gnCollar').textContent = k.collar;
      document.getElementById('gnOcc').textContent = k.occ;
      document.getElementById('gnTip').textContent = '“' + k.tip + '”';

      curSteps = k.steps;
      stepsWrap.innerHTML = '';
      dotsWrap.innerHTML = '';
      k.steps.forEach(function (s, i) {
        var row = document.createElement('div');
        row.className = 'gn-step';
        row.setAttribute('role', 'button');
        row.setAttribute('tabindex', '0');
        row.innerHTML = '<span class="n">' + (i + 1) + '.</span><p>' + s[1] + '</p>';
        var jump = function () { goStep(i); startAuto(); };
        row.addEventListener('click', jump);
        row.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); jump(); }
        });
        stepsWrap.appendChild(row);

        var dot = document.createElement('button');
        dot.setAttribute('aria-label', 'Vai al passo ' + (i + 1));
        dot.addEventListener('click', function () { goStep(i); startAuto(); });
        dotsWrap.appendChild(dot);
      });
      playing = !reduced;
      ppBtn.textContent = playing ? '❚❚' : '▶';
      goStep(0);
      startAuto();

      if (scroll) {
        document.getElementById('dettaglio').scrollIntoView({ behavior: 'smooth' });
      }
    }
    selectKnot('quattro-mani', false);

    /* ---------- Hero thread ---------- */
    var heroSvg = document.getElementById('gnHeroThread');
    if (heroSvg) {
      Array.prototype.forEach.call(heroSvg.querySelectorAll('path'), function (p, i) {
        p.setAttribute('pathLength', '1');
        p.style.setProperty('--i', i * 1.1);
      });
      setTimeout(function () { heroSvg.classList.add('play'); }, 350);
    }

    /* ---------- Reveal per gli elementi creati via JS ---------- */
    if (!reduced && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-in');
            var t = e.target.querySelector('svg.gn-thread');
            if (t) playThread(t);
            io.unobserve(e.target);
          }
        });
      }, { threshold: 0.15 });
      document.querySelectorAll('.gn-rev').forEach(function (el) { io.observe(el); });
    } else {
      document.querySelectorAll('.gn-rev').forEach(function (el) { el.classList.add('is-in'); });
      document.querySelectorAll('svg.gn-thread').forEach(function (t) { t.classList.add('play'); });
    }
  });
})();
